module.exports = __webpack_public_path__ + "img/whats-new-9_en.3ca7bcb.jpg";